"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const redux_1 = require("redux");
const consts_1 = require("~/consts/consts");
const useCatalogItemClickHandler_1 = __importDefault(require("~/hooks/useCatalogItemClickHandler"));
const actions_1 = require("~/store/actions");
const consts_2 = require("~/store/consts");
const selectors_1 = require("~/store/selectors");
const events_1 = require("~/utils/events");
const utils_1 = require("~/utils/utils");
const catalogUtils_1 = __importDefault(require("~/utils/catalogUtils"));
const CatalogCategoryToggler_1 = __importDefault(require("../CatalogCategoryToggler"));
const CatalogGroup_1 = require("../CatalogGroup");
const CatalogTile_1 = require("../CatalogTile");
const CatalogTileTooltip_1 = require("../CatalogTileTooltip");
const CategoryHeader_1 = __importDefault(require("../CategoryHeader"));
function CatalogCategory() {
    const catalogData = (0, react_redux_1.useSelector)(selectors_1.selectCatalogItems);
    const selectedItem = (0, react_redux_1.useSelector)(selectors_1.selectSelectedItem);
    const isBOMEditMode = (0, react_redux_1.useSelector)(selectors_1.selectBOMEditMode);
    const manuallySavedItems = (0, react_redux_1.useSelector)(selectors_1.selectManuallySavedItems);
    const isDefaultFastenersWidgetShown = (0, react_redux_1.useSelector)((0, selectors_1.selectIsWidgetShown)(consts_2.WIDGETS.DEFAULT_FASTENER_WIDGET));
    const isCurrentFastenersWidgetShown = (0, react_redux_1.useSelector)((0, selectors_1.selectIsWidgetShown)(consts_2.WIDGETS.CURRENT_FASTENER_WIDGET));
    const isItemReplacementWidgetShown = (0, react_redux_1.useSelector)((0, selectors_1.selectIsWidgetShown)(consts_2.WIDGETS.ITEM_REPLACEMENT_WIDGET));
    const itemClickHandler = (0, useCatalogItemClickHandler_1.default)();
    const { dispatchSelectItem } = (0, redux_1.bindActionCreators)({
        dispatchSelectItem: actions_1.selectItem,
    }, (0, react_redux_1.useDispatch)());
    const catalogItemClickHandler = (value) => {
        if ((0, utils_1.isICatalogItem)(value)) {
            itemClickHandler(value);
        }
        else {
            if (isDefaultFastenersWidgetShown ||
                isCurrentFastenersWidgetShown ||
                isItemReplacementWidgetShown ||
                value.id === (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.id)) {
                return;
            }
            (0, events_1.showNotification)({
                message: consts_1.ADDING_MS_NOTIFICATION,
                type: 'info',
            });
            dispatchSelectItem(value);
        }
    };
    const isMachiningServiceApplicable = (machiningService) => {
        return Object.keys(manuallySavedItems).reduce((isApplicable, key) => isApplicable || (0, catalogUtils_1.default)(machiningService, manuallySavedItems[key]), false);
    };
    // deselecting item if it becomes inapplicable
    (0, react_1.useEffect)(() => {
        if (selectedItem && !(0, utils_1.isICatalogItem)(selectedItem) && !isMachiningServiceApplicable(selectedItem)) {
            dispatchSelectItem(null);
        }
    }, [manuallySavedItems, selectedItem]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(CategoryHeader_1.default, null),
        react_1.default.createElement(CatalogCategoryToggler_1.default, null),
        react_1.default.createElement(CatalogGroup_1.CatalogGroup, null, catalogData.map((catalogItem) => {
            var _a, _b, _c, _d, _e;
            if ((0, utils_1.isICatalogItem)(catalogItem)) {
                const { extrusionType } = catalogItem;
                return (react_1.default.createElement(CatalogTile_1.CatalogTile, { key: catalogItem.item_number, id: catalogItem.id, imageURI: (_a = catalogItem.image) === null || _a === void 0 ? void 0 : _a.url, label: `#${catalogItem.item_number} - ${catalogItem.description}`, onClick: catalogItemClickHandler, value: catalogItem, active: catalogItem.id === (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.id), disabled: !isBOMEditMode &&
                        (!catalogItem.cadFileExists || !catalogItem.meshFileExists || !catalogItem.csvFileExists), canBeMitered: (_b = extrusionType === null || extrusionType === void 0 ? void 0 : extrusionType.canBeMitered) !== null && _b !== void 0 ? _b : true, tooltip: {
                        contentNode: react_1.default.createElement(CatalogTileTooltip_1.CatalogTileTooltip, { label: catalogItem.description, imageURI: (_c = catalogItem.image) === null || _c === void 0 ? void 0 : _c.url }),
                        placement: 'right-start',
                    } }));
            }
            return (react_1.default.createElement(CatalogTile_1.CatalogTile, { key: catalogItem.itemNumber, id: catalogItem.id, imageURI: (_d = catalogItem.image) === null || _d === void 0 ? void 0 : _d.url, label: `#${catalogItem.itemNumber} - ${catalogItem.description}`, onClick: catalogItemClickHandler, value: catalogItem, active: catalogItem.id === (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.id), disabled: !isMachiningServiceApplicable(catalogItem), tooltip: {
                    contentNode: react_1.default.createElement(CatalogTileTooltip_1.CatalogTileTooltip, { label: catalogItem.description, imageURI: (_e = catalogItem.image) === null || _e === void 0 ? void 0 : _e.url }),
                    placement: 'right-start',
                } }));
        }))));
}
exports.default = CatalogCategory;
